import React, { useContext, useState } from 'react'
import _ from 'lodash'
import { Auth } from 'aws-amplify'
import { Divider, Button, Form } from 'antd'
import common from '@/utils/common'
import { Text, Input } from '@/style-guide'
import { AuthContext } from '../AuthContext'
import { setItemStorage } from '@/utils/storage'

export const SignupForm = ({ showGoogle = true, onShowOtherLogin }) => {
  const { setStep, setPayload } = useContext(AuthContext)
  const [form] = Form.useForm()
  const [isLoading, setLoading] = useState(false)

  // Function to generate username from email
  const generateUsernameFromEmail = (email) => {
    return email.replace('@', '').toLowerCase()
  }

  const signup = async (values) => {
    let name = values.fullName.split(' ')
    // Auto-generate username from email
    const username = generateUsernameFromEmail(values.email)
    
    const payload = {
      firstName: name[0],
      email: common.emailTruncateLable(values.email.toLowerCase()),
      password: values.password,
      username: username,
    }
    if (name.length > 1) {
      name.shift()
      payload['lastName'] = name.join(' ')
    }
    try {
      setLoading(true)
      await Auth.signUp({
        username: payload.email,
        password: payload.password,
        attributes: {
          'custom:firstName': payload.firstName,
          'custom:lastName': payload.lastName,
          'custom:username': payload.username,
        },
        autoSignIn: {
          // optional - enables auto sign in after user is confirmed
          enabled: true,
        },
      })
      setPayload(payload)
      setStep('confirm-email')
    } catch (err) {
      common.errorToast(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Form
        form={form}
        name="normal_login"
        initialValues={{ email: '', password: '', fullName: '' }}
        onFinish={signup}
        scrollToFirstError
      >
        <Form.Item
          hasFeedback
          name="email"
          rules={[
            {
              type: 'email',
              message: 'The input is not valid E-mail!',
            },
            { required: true, message: 'Please input your E-mail!' },
          ]}
        >
          <Input label="Email address" />
        </Form.Item>
        <Form.Item
          hasFeedback
          name="fullName"
          rules={[{ required: true, message: 'Please input your full name' }]}
        >
          <Input label="Full name" />
        </Form.Item>
        <Form.Item
          name="password"
          hasFeedback
          rules={[
            { required: true, message: 'Please input your password' },
            { min: 8, message: 'Password should be at least 8 characters.' },
            {
              pattern: /[A-Z]/,
              message: 'Password must contain at least one uppercase letter',
            },
            {
              pattern: /[a-z]/,
              message: 'Password must contain at least one lowercase letter',
            },
            {
              pattern: /[0-9]/,
              message: 'Password must contain at least one number',
            },
          ]}
        >
          <Input label="Password" htmlType="password" />
        </Form.Item>
        <Form.Item>
          <Button
            loading={isLoading}
            type="primary"
            htmlType="submit"
            block
            size="large"
            className="xl-btn"
          >
            Sign up
          </Button>
        </Form.Item>
      </Form>
      {showGoogle && (
        <>
          <Divider>OR</Divider>
          <Button
            className="xl-btn"
            size="large"
            type="ghost"
            block
            onClick={() => {
              setItemStorage('redirectUrl', window.location.pathname)
              Auth.federatedSignIn({ provider: 'Google' })
            }}
          >
            <span className="google" />
            Sign up using Google
          </Button>
        </>
      )}
      <div className="footer">
        <Text size={16}>
          Already have an account?{' '}
          <Text className="link-text" onClick={() => setStep('login')}>
            Log in
          </Text>
        </Text>

        <Text size={16}>
          By signing up to Tripsha you agree to abide by our
          <a
            href="https://www.tripsha.com/policies"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            Terms of Service{' '}
          </a>
          and
          <a
            href="https://www.tripsha.com/policies"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            Privacy Policy{' '}
          </a>
        </Text>
        {onShowOtherLogin && (
          <Text size={16} style={{ marginTop: 16, display: 'block' }}>
            <Text className="link-text" onClick={onShowOtherLogin}>
              Use other login options &gt;
            </Text>
          </Text>
        )}
      </div>
    </>
  )
}
